import React from "react";

import { Field } from "formik";
import { useSelector } from "react-redux";

import { SelectField, withNamespace } from "components/Form/FormikControls";
import { Row } from "components/Layout";

import { selectLedgerAccountOptionsForRuleBuilder } from "selectors";

export function CustomiseManagedRuleForm(props) {
  const { namespace: ns } = props;

  const LedgerAccountOptions = useSelector(
    selectLedgerAccountOptionsForRuleBuilder,
  );

  return (
    <>
      <Row full alignCenter paddingVertical={1}>
        <span>Name:</span>&nbsp;
        <Field
          data-tour="name"
          className="p-2 flex-1"
          name={withNamespace(ns, "name")}
        />
      </Row>

      <Row full alignCenter paddingVertical={1}>
        <span>Comment:</span>&nbsp;
        <Field
          data-tour="comment"
          className="p-2 flex-1"
          name={withNamespace(ns, "comment")}
          as="textarea"
        />
      </Row>
      <Row full alignCenter paddingVertical={1}>
        <span>Title Template:</span>&nbsp;
        <Field
          data-tour="titleTemplate"
          className="p-2 flex-1"
          name={withNamespace(ns, "title_template")}
        />
      </Row>
      <Row full alignCenter paddingVertical={1}>
        <span>Invoice Line Item Template:</span>&nbsp;
        <Field
          data-tour="invoiceLineItemTemplate"
          className="p-2 flex-1"
          name={withNamespace(ns, "invoice_line_item_template")}
        />
      </Row>
      <Row full alignCenter paddingVertical={1}>
        <span>GL Code:</span>&nbsp;
        <SelectField
          data-tour="glCode"
          name={withNamespace(ns, "gl_code")}
          required
          options={LedgerAccountOptions}
          menuPortalTarget={document.body}
          tooltip="This chart of accounts is maintained by AgriNous."
        />
      </Row>
    </>
  );
}
